import { ChatResponseType, ChatStructuredData } from '@distribute/shared/types';

export const isRelevantSuggestion = (item: ChatStructuredData) =>
  item.type === ChatResponseType.Suggestion && item.changed;

export const isRelevantResponse = (item: ChatStructuredData) =>
  item.type === ChatResponseType.Comment || isRelevantSuggestion(item);
